export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const ORDER_LIST = 'ORDER_LIST'; 
export const ADD_ORDER = 'ADD_ORDER'; 
export const REPORTING = 'REPORTING';


export const SUPP_ADMIN = 'SUPPLIER_ADMIN';
export const SUPPLIER_ADD_CLAIM = 'SUPPLIER_ADD_CLAIM';
export const SUPPLIER_CLAIM_LIST = 'SUPPLIER_CLAIM_LIST';
export const SUPPLIER_CLAIM_SERVICE_MANAGER = 'SUPPLIER_CLAIM_SERVICE_MANAGER';
export const SUPPLIER_ADD_ORDER = 'SUPPLIER_ADD_ORDER';
export const SUPPLIER_DOCUMENT_ACCESS = 'SUPPLIER_DOCUMENT_ACCESS';

const isReportingSupplierEnabled = process.env.VUE_APP_FEATURE_REPORTING_SUPPLIER === 'true';

const isBcSupplierEnabled = process.env.VUE_APP_FEATURE_BC_SUPPLIER === 'true';

export const menuItems = [
    
    ///////////////////
    // Customer Menu 

    {
        id: 1,
        label: 'Accueil',
        icon: 'fas fa-home',
        withIcon: true,
        subItems:[],
        link: '/', 
        role:CUSTOMER_ROLE,
        
    },

    {
        id: 2,
        label: 'Catalogue',
        link: '/catalogue',
        icon: 'fas fa-shopping-cart',
        role:CUSTOMER_ROLE,
        subRole: [
            CUSTOMER_ADMIN,
            ADD_ORDER
        ]
     
    },
    
    {
        id: 8,
        label: 'Documents',
        link: '/commandes',
        icon: 'far fa-file-alt ',
        subItems:[],
        role:CUSTOMER_ROLE,
        subRole: [
            CUSTOMER_ADMIN,
            ORDER_LIST
        ]
    
    },
    
    {
        id: 103,
        label: 'Utilisateurs',
        icon: 'fas fa-user-cog',
        link: 'customer-utilisateurs',
        role:CUSTOMER_ROLE,
        subRole: [
            CUSTOMER_ADMIN
        ]
    },

    
    {
        id: 11,
        label: 'Reclamation',
        link: '/claim',
        icon: 'far fa-file-alt ',
        subItems:[],
        role:CUSTOMER_ROLE,
    },


    {
        id: 10,
        label: 'Rapports',
        link: '/reporting',
        icon: 'far fa-file-alt ',
        subItems:[],
        role:CUSTOMER_ROLE,
        subRole: [
            REPORTING,
            CUSTOMER_ADMIN,
              
        ] 
    },

    ///////////////////
    // Supplier Menu 
    
    {
        id: 100,
        label: 'Accueil',
        icon: 'fas fa-home',
        subItems:[],
        link: '/',
        role:SUPPLIER_ROLE,
        isPartner: true,
    },


    {
        id: 101,
        label: 'Catalogue',
        link: '/catalogue',
        icon: 'fas fa-shopping-cart',
        role:SUPPLIER_ROLE,
        isPartner: true,
        subRole: [
            SUPPLIER_ADD_ORDER, 
            SUPP_ADMIN             
        ] 
    },

    {
        id: 102,
        label: 'Documents',
        link: '/commandes',
        icon: 'far fa-file-alt',
        role:SUPPLIER_ROLE,
        isPartner: false,
        subRole: [
            SUPP_ADMIN,
            SUPPLIER_DOCUMENT_ACCESS           
        ] 

    },

    {
        id: 104,
        label: 'Utilisateurs',
        icon: 'fas fa-user-cog',
        link:'/utilisateurs',
        role:SUPPLIER_ROLE,
        isPartner: false,      
        subRole: [
            SUPP_ADMIN             
        ] 
    },

    // {
    //     id: 104,
    //     label: 'Articles',
    //     icon: 'fas fa-sync ',
    //     isUiElement: true,
    //     link:'/articles',
    //     role:SUPPLIER_ROLE,

    // },

    {
        id: 105,
        label: 'Configuration',
        icon: 'fas fa-bullhorn ',
        subItems:[],
        link:"/bannieres",
        role:SUPPLIER_ROLE,
        isPartner: false,
        subRole: [
            SUPP_ADMIN             
        ] 
    },

    {
        id: 106,
        label: 'Reporting',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/reporting",
        role:SUPPLIER_ROLE,
        subRole: [
            SUPP_ADMIN             
        ] 
    },

    {
        id: 108,
        label: 'Reclamation',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/claim",
        role:SUPPLIER_ROLE,  
        isPartner: false,
        subRole: [
            SUPP_ADMIN,
            SUPPLIER_ADD_CLAIM, 
            SUPPLIER_CLAIM_LIST,
            SUPPLIER_CLAIM_SERVICE_MANAGER        
        ] 
    },

    ...(isReportingSupplierEnabled ? [{
        id: 107,
        label: 'Reporting',
        icon: 'fas fa-chart-line ',
        subItems: [],
        link: "/reporting-partner",
        role: SUPPLIER_ROLE,
        isPartner: true,
        onlyPartner: true,
    }] : []),

    ...(isBcSupplierEnabled ? [{
        id: 108,
        label: 'Cmdes Fournisseur',
        icon: 'fas fa-chart-line ',
        subItems: [],
        link: "/bc-frs-partner",
        role: SUPPLIER_ROLE,
        isPartner: true,
        onlyPartner: true,
    }] : []),

 

];

